export const addReportTableModalQueryKeys = {
  all: ['AddReportTableModal'] as const,
  spreadsheets: (publicationId: string) =>
    [...addReportTableModalQueryKeys.all, 'spreadsheets', publicationId] as const,
  namedRanges: (spreadsheetId: string) => [...addReportTableModalQueryKeys.all, 'namedRanges', spreadsheetId] as const
};
